/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CloseFacilityCommand } from '../models/CloseFacilityCommand';
import type { CreateFacilityCommand } from '../models/CreateFacilityCommand';
import type { CreateFacilityResponseDto } from '../models/CreateFacilityResponseDto';
import type { CreateSublimitDto } from '../models/CreateSublimitDto';
import type { DeleteFacilityCommand } from '../models/DeleteFacilityCommand';
import type { FacilitiesChartInfoDto } from '../models/FacilitiesChartInfoDto';
import type { FacilityDocumentInfoDto } from '../models/FacilityDocumentInfoDto';
import type { FacilityHistoryDetailDto } from '../models/FacilityHistoryDetailDto';
import type { FacilityHistoryDto } from '../models/FacilityHistoryDto';
import type { FacilityListDtoPaginatedResult } from '../models/FacilityListDtoPaginatedResult';
import type { RenewalListDto } from '../models/RenewalListDto';
import type { RenewFacilityCommand } from '../models/RenewFacilityCommand';
import type { SummaryDto } from '../models/SummaryDto';
import type { UploadFacilityDocumentDto } from '../models/UploadFacilityDocumentDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class FacilitiesService {
    /**
     * @param id
     * @returns FacilityDocumentInfoDto OK
     * @throws ApiError
     */
    public static getApiFacilitiesDocuments(
        id: string,
    ): CancelablePromise<Array<FacilityDocumentInfoDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Facilities/{id}/documents',
            path: {
                'id': id,
            },
            errors: {
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param id
     * @param formData
     * @returns string OK
     * @throws ApiError
     */
    public static putApiFacilitiesDocuments(
        id: string,
        formData?: {
            Data?: Array<UploadFacilityDocumentDto>;
        },
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/Facilities/{id}/documents',
            path: {
                'id': id,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param filterByFacilityStatus
     * @param filterByBank
     * @param filterByOpenDateStart
     * @param filterByOpenDateEnd
     * @param filterByRenewalDateStart
     * @param filterByRenewalDateEnd
     * @returns FacilitiesChartInfoDto OK
     * @throws ApiError
     */
    public static getApiFacilitiesChart(
        filterByFacilityStatus?: Array<string>,
        filterByBank?: Array<string>,
        filterByOpenDateStart?: string,
        filterByOpenDateEnd?: string,
        filterByRenewalDateStart?: string,
        filterByRenewalDateEnd?: string,
    ): CancelablePromise<FacilitiesChartInfoDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Facilities/chart',
            query: {
                'FilterByFacilityStatus': filterByFacilityStatus,
                'FilterByBank': filterByBank,
                'FilterByOpenDateStart': filterByOpenDateStart,
                'FilterByOpenDateEnd': filterByOpenDateEnd,
                'FilterByRenewalDateStart': filterByRenewalDateStart,
                'FilterByRenewalDateEnd': filterByRenewalDateEnd,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns CreateFacilityResponseDto Created
     * @throws ApiError
     */
    public static postApiFacilities(
        requestBody?: CreateFacilityCommand,
    ): CancelablePromise<CreateFacilityResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Facilities',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param pageNumber
     * @param pageSize
     * @param filterByFacilityStatus
     * @param filterByBank
     * @param filterByCompany
     * @param filterByOpenDateStart
     * @param filterByOpenDateEnd
     * @param filterByRenewalDateStart
     * @param filterByRenewalDateEnd
     * @param sortBy
     * @param sortOrder
     * @returns FacilityListDtoPaginatedResult OK
     * @throws ApiError
     */
    public static getApiFacilities(
        pageNumber?: number,
        pageSize?: number,
        filterByFacilityStatus?: Array<string>,
        filterByBank?: Array<string>,
        filterByCompany?: Array<string>,
        filterByOpenDateStart?: string,
        filterByOpenDateEnd?: string,
        filterByRenewalDateStart?: string,
        filterByRenewalDateEnd?: string,
        sortBy?: string,
        sortOrder?: string,
    ): CancelablePromise<FacilityListDtoPaginatedResult> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Facilities',
            query: {
                'PageNumber': pageNumber,
                'PageSize': pageSize,
                'FilterByFacilityStatus': filterByFacilityStatus,
                'FilterByBank': filterByBank,
                'FilterByCompany': filterByCompany,
                'FilterByOpenDateStart': filterByOpenDateStart,
                'FilterByOpenDateEnd': filterByOpenDateEnd,
                'FilterByRenewalDateStart': filterByRenewalDateStart,
                'FilterByRenewalDateEnd': filterByRenewalDateEnd,
                'SortBy': sortBy,
                'SortOrder': sortOrder,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param id
     * @returns any OK
     * @throws ApiError
     */
    public static getApiFacilities1(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Facilities/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns string OK
     * @throws ApiError
     */
    public static deleteApiFacilities(
        id: string,
        requestBody?: DeleteFacilityCommand,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/Facilities/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param selectedFacilities
     * @param unselectedFacilities
     * @param filterByFacilityStatus
     * @param filterByBank
     * @param filterByCompany
     * @param filterByOpenDateStart
     * @param filterByOpenDateEnd
     * @param filterByRenewalDateStart
     * @param filterByRenewalDateEnd
     * @param sortBy
     * @param sortOrder
     * @param timeZone
     * @returns binary OK
     * @throws ApiError
     */
    public static getApiFacilitiesExport(
        selectedFacilities?: Array<string>,
        unselectedFacilities?: Array<string>,
        filterByFacilityStatus?: Array<string>,
        filterByBank?: Array<string>,
        filterByCompany?: Array<string>,
        filterByOpenDateStart?: string,
        filterByOpenDateEnd?: string,
        filterByRenewalDateStart?: string,
        filterByRenewalDateEnd?: string,
        sortBy?: string,
        sortOrder?: string,
        timeZone?: string,
    ): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Facilities/export',
            query: {
                'SelectedFacilities': selectedFacilities,
                'UnselectedFacilities': unselectedFacilities,
                'FilterByFacilityStatus': filterByFacilityStatus,
                'FilterByBank': filterByBank,
                'FilterByCompany': filterByCompany,
                'FilterByOpenDateStart': filterByOpenDateStart,
                'FilterByOpenDateEnd': filterByOpenDateEnd,
                'FilterByRenewalDateStart': filterByRenewalDateStart,
                'FilterByRenewalDateEnd': filterByRenewalDateEnd,
                'SortBy': sortBy,
                'SortOrder': sortOrder,
                'TimeZone': timeZone,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @returns SummaryDto OK
     * @throws ApiError
     */
    public static getApiFacilitiesSummary(): CancelablePromise<SummaryDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Facilities/summary',
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns string OK
     * @throws ApiError
     */
    public static patchApiFacilitiesClose(
        id: string,
        requestBody?: CloseFacilityCommand,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/Facilities/{id}/close',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param facilityId
     * @param requestBody
     * @returns any Created
     * @throws ApiError
     */
    public static putApiFacilitiesSublimits(
        facilityId: string,
        requestBody?: Array<CreateSublimitDto>,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/Facilities/{facilityId}/sublimits',
            path: {
                'facilityId': facilityId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param facilityId
     * @param requestBody
     * @returns string OK
     * @throws ApiError
     */
    public static postApiFacilitiesRenew(
        facilityId: string,
        requestBody?: RenewFacilityCommand,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Facilities/{facilityId}/renew',
            path: {
                'facilityId': facilityId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get all renewals of facility
     * @param facilityId
     * @param filterByRenewalDateStart
     * @param filterByRenewalDateEnd
     * @param sortBy
     * @param sortOrder
     * @returns RenewalListDto OK
     * @throws ApiError
     */
    public static getApiFacilitiesRenewals(
        facilityId: string,
        filterByRenewalDateStart?: string,
        filterByRenewalDateEnd?: string,
        sortBy?: string,
        sortOrder?: string,
    ): CancelablePromise<Array<RenewalListDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Facilities/{facilityId}/renewals',
            path: {
                'facilityId': facilityId,
            },
            query: {
                'FilterByRenewalDateStart': filterByRenewalDateStart,
                'FilterByRenewalDateEnd': filterByRenewalDateEnd,
                'SortBy': sortBy,
                'SortOrder': sortOrder,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param facilityId
     * @returns FacilityHistoryDto OK
     * @throws ApiError
     */
    public static getApiFacilitiesHistory(
        facilityId: string,
    ): CancelablePromise<Array<FacilityHistoryDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Facilities/{facilityId}/history',
            path: {
                'facilityId': facilityId,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param entityId
     * @param validTo
     * @param type
     * @returns FacilityHistoryDetailDto OK
     * @throws ApiError
     */
    public static getApiFacilitiesHistory1(
        entityId: string,
        validTo?: string,
        type?: string,
    ): CancelablePromise<Array<FacilityHistoryDetailDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Facilities/history/{entityId}',
            path: {
                'entityId': entityId,
            },
            query: {
                'ValidTo': validTo,
                'Type': type,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @returns binary OK
     * @throws ApiError
     */
    public static getApiFacilitiesFacilityReport(): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Facilities/FacilityReport',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
}
